// NOTE: NSAI-3304 — socket event and shared caps for sandboxed skill-script runs.
// The event name must match the server constant exactly.
export const SKILL_SCRIPT_RUN_SOCKET_EVENT = "skillScriptRun";

// NOTE: Mirrors the server's log cap so a client can size its own display without
// waiting for a record to arrive. The server remains the enforcing side.
export const SKILL_SCRIPT_MAX_LOG_BYTES = 1_048_576;

// NOTE: How much of stdout/stderr a transcript shows before collapsing it behind a
// control. Purely presentational; the server already truncated to the cap above.
export const SKILL_SCRIPT_LOG_PREVIEW_LINES = 12;
